import React, { Component } from 'react';
import { BrowserRouter }from 'react-router-dom'
import Layout from './Components/Layout/Layout'
import './App.css';
import Home from './Containers/Home/Home'
import {Route} from 'react-router-dom'
import Register from './Containers/Register/Register';
import Login from './Containers/Login/Login'
import {connect} from 'react-redux'
import * as actions from './Store/Action/index'
import  './App.css'
import StudyMaterial from './Containers/StudyMaterial/StudyMaterial';
import BillingPage from './Containers/BillingPage/BillingPage'
import CoursePage from './Containers/Course/CoursePage'
import TokenizedCoursePage from './Containers/Course/TokenizedCoursePage'
import Webinar from './Containers/Webinar/Webinar';


class App extends Component {
  componentDidMount(){
    this.props.onAutoSignUp()
 }
  render(){
  return (
    <div  style={{'font-family': 'Raleway'}} className="App">
     <Route path='/course' exact component = {CoursePage}></Route>
      <Route path='/testcourse/:id' exact component = {TokenizedCoursePage}></Route>
     <Route path='/webinar' exact component = {Webinar}></Route>
     <Route path='/' exact component={Webinar}></Route>
      {/*<Route path='/' exact component={CoursePage}></Route>*/}
    </div>
  );
}}
const mapDispatchToProps = (dispatch)=>{
  return{
    onAutoSignUp:()=>dispatch(actions.checkAuthState())
  }
}
const mapStateToProps = (state)=>{
  return{
    isAuth:state.auth.token!==null
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(App);
